<template>
  <div>
    <div v-if="emptyValue">
      <v-textarea
        :disabled="!editable"
        v-model="editedContent"
        label="Observaciones"
        prepend-icon="mdi-text"
        textarea
        auto-grow
        dense
        rows="1"
        @blur="saveContent"
      />
    </div>
    <div v-else-if="isEditing">
      <v-textarea
        v-model="editedContent"
        label="Observaciones"
        prepend-icon="mdi-pencil"
        textarea
        auto-grow
        dense
        rows="1"
      />
      <div class="d-flex justify-end">
        <v-btn small @click="cancelEditing">Cancelar</v-btn>
        <v-btn color="primary" small class="ml-2" @click="saveContent"
          >Guardar</v-btn
        >
      </div>
    </div>
    <div v-else>
      <label for="advanced-observation">Observaciones</label>
      <div class="d-flex align-start">
        <!-- start icon -->
        <v-icon class="mr-2">mdi-text</v-icon>
        <RendererRichText
          :title="editable ? 'Doble click para editar' : ''"
          @dblclick="editable ? startEditing() : null"
          :value="value"
        />
      </div>
      <span v-if="editable" class="text-caption">Doble click para editar</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "AdvancedObservation",
  components: {
    RendererRichText: () => import("./rendererRichText.vue")
  },
  props: {
    value: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEditing: false,
      editedContent: this.value
    };
  },
  computed: {
    emptyValue() {
      return !this.value?.trim();
    }
  },
  methods: {
    startEditing() {
      this.isEditing = true;
      this.editedContent = this.value;
    },
    updateContent() {
      this.$emit("input", this.editedContent);
    },
    cancelEditing() {
      this.isEditing = false;
      this.editedContent = this.value;
    },
    saveContent() {
      this.$emit("input", this.editedContent);
      this.$emit("save", true);
      this.isEditing = false;
    }
  }
};
</script>
<style scoped>
.message-content {
  cursor: pointer;
}

.message-content:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
